import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    const dismissed = localStorage.getItem("welcome_modal_dismissed")
    if (dismissed) {
      const dismissedAt = new Date(dismissed)
      const now = new Date()
      const diffDays = (now - dismissedAt) / (1000 * 60 * 60 * 24)
      if (diffDays < 3) {
        this.element.remove()
        return
      }
    }
    this.element.style.display = "flex"
  }

  goToGuide() {
    this.element.remove()
    window.location.href = "/guides"
  }

  dismissFor3Days() {
    localStorage.setItem("welcome_modal_dismissed", new Date().toISOString())
    this.close()
  }

  close() {
    this.element.remove()
  }
}
